import { ACCESSIBILITY_MIN_CONTRAST } from '@plugins/client/colors/constants';

import {
  Accessibility,
  ColorAccessibility,
} from '../../public/shared-button/types';

export const PRIMARY_COLORS = [
  'primary',
  'secondary',
  'success',
  'warning',
] as const;
export const OUTLINE_COLORS = PRIMARY_COLORS.map(
  (color) => `${color}-outline` as const,
);

export const TEXT_COLORS = PRIMARY_COLORS.map(
  (color) => `${color}-text` as const,
);

export const CUSTOM_PLUGIN_CLASSES = [
  'plugins-primary',
  'plugins-secondary',
] as const;
export const ALL_COLORS = [
  ...PRIMARY_COLORS,
  ...OUTLINE_COLORS,
  ...TEXT_COLORS,
  ...CUSTOM_PLUGIN_CLASSES,
];
export const SHADOW_OPACITY = 0.4;
export const TEXT_HOVER_OPACITY = 0.1;

export const SIZE_CLASSES = ['sm', 'md', 'lg', 'xl'] as const;
export const SIZE_VARIABLES = [
  ...SIZE_CLASSES,
  'sm-font',
  'md-font',
  'lg-font',
  'xl-font',
  'hMultiplier',
  'round-base-size',
  'round-multiplier',
] as const;

export const DEFAULT_CONTRAST_VALUES: ColorAccessibility = {
  lowContrastReturn: '#000000',
  text: ACCESSIBILITY_MIN_CONTRAST,
  minimum: 1.2,
  contrastingColor: '#FFFFFF',
};

export const ARIA_CAMEL_TO_KEBAB_CASE: Record<keyof Accessibility, string> = {
  role: 'role',
  ariaActiveDescendant: 'aria-activedescendant',
  ariaControls: 'aria-controls',
  ariaDescription: 'aria-description',
  ariaLabel: 'aria-label',
  ariaExpanded: 'aria-expanded',
  ariaHasPopup: 'aria-haspopup',
  ariaInvalid: 'aria-invalid',
  ariaOwns: 'aria-owns',
  ariaPressed: 'aria-pressed',
  ariaSelected: 'aria-selected',
};
export const LIGHTNESS_LIMIT = 65;
